import { Component, OnDestroy, OnInit, ɵɵqueryRefresh } from '@angular/core';
import { PubService, CreatePubResponse , DeletePubResponse} from 'src/app/Services/pub/pub.service';
import {Pub, Comment ,LikeShareResponse} from 'src/app/Models/pub.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { User } from 'src/app/Models/User';
import { UserService } from 'src/app/Services/User/user.service';
import { faFlag, faMapMarker, faUniversity, faCalendar, faInfoCircle, faBrain, faObjectGroup, faEnvelope } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-pub',
  templateUrl: './pub.component.html',
  styleUrls: ['./pub.component.scss']
})
export class PubComponent implements OnInit {
  userComment: string = '';
  displayedCommentsCount: number = 2;
  //uploadedImageUrl: string | null = '';
  uploadedImageUrl: SafeResourceUrl | null = null;
  uploadedVideoUrl: string | null = '';
  user: User = null;
  id: any = null;

  
  nomInstitut = "Admin";
  uploadedImage: File | null = null;
  uploadedVideo: File | null = null;
  content: string = '';
  pubs: Pub[] = [];
  userLogo: any=null;
  clubName: string = '';
  pubTime: string = 'Just now';
  selectedPub: Pub | null = null;

  date = new Date().getUTCFullYear();
  nextYears = parseInt((this.date).toString()) + 1
  
  faFlag = faFlag;
  faMapMarker = faMapMarker;
  faUniversity = faUniversity;
  faCalendar = faCalendar;
  faInfoCircle = faInfoCircle;
  faBrain = faBrain;
  faObjectGroup = faObjectGroup;
  faEnvelope = faEnvelope;

  constructor(private pubService: PubService , private sanitizer: DomSanitizer , private userService: UserService  ) { }

  ngOnInit(): void {
    
    this.findUserById();
    this.fetchPubs();
  }
  findUserById() {
    this.id = localStorage.getItem("Id");
    this.userService.findById(this.id).subscribe(data => {
        this.user = data;
        
        // Make sure to handle if profileImage doesn't exist or it is in a specific property in profileImage
        const profileImageName = this.user.profileImage;
        console.log("profileimage" , profileImageName)
        
            this.userLogo = `http://localhost:9091/User/${profileImageName}`; 
        
        
        this.clubName = this.user.nom + ' ' + this.user.prenom;

        if (localStorage.getItem("Roles").includes("ADMINISTRATEUR")) {
            this.nomInstitut = "Administrateur";
        } else if (localStorage.getItem("Roles").includes("UNIVERSITE")) {
            this.nomInstitut = "Universite";
        } else {
            this.nomInstitut = this.user.institut.nom
        }
        return this.user;
    })
}
fetchPubs(): void {
  const userId = localStorage.getItem("Id"); // assuming the user Id is stored in local storage
  this.pubService.getPubsByUser(userId).subscribe(
    (response: any) => {
      this.pubs = response.pubs.map((pub: Pub) => {
        pub.imageUrl = pub.imageUrl ? `http://localhost:9091/${pub.imageUrl}` : null;
        pub.videoUrl = pub.videoUrl ? `http://localhost:9091/${pub.videoUrl}` : null;
        
        // Map the comments array to match the Comment model structure
        pub.comments = pub.comments.map((comment: any) => ({
          text: comment.text,
          showOptions: comment.showOptions,
          editing: comment.editing
        }));

        return pub;
      }).reverse();
      console.log(response);
    },
    (error) => {
      console.error('Failed to fetch pub:', error);
    }
  );
}

  openCreateModal(): void {
    this.selectedPub = null;
    this.content = "";
    this.uploadedImage = null;
    this.uploadedVideo = null;
    const modelDiv = document.getElementById("myModal");
    if (modelDiv != null) {
      modelDiv.style.display = "block";
    }
  }

  closeModel() {
    const modelDiv = document.getElementById('myModal');
    if (modelDiv != null) {
      modelDiv.style.display = 'none';
    }
  }
  /*onFileSelected(event: Event): void {
    const fileInput = event.target as HTMLInputElement;
    if (fileInput.files && fileInput.files[0]) {
      const file = fileInput.files[0];
      if (file.type.startsWith('image/')) {
        this.uploadedImage = file;
        this.uploadedVideo = null;
        // Create a URL for the selected image file for preview.
        this.uploadedImageUrl = URL.createObjectURL(file);
       
        console.log("img",this.uploadedImageUrl)
      }
    }
  }*/
  //test on fle selected
  onFileSelected(event: Event): void {
    const fileInput = event.target as HTMLInputElement;
    if (fileInput.files && fileInput.files[0]) {
      const file = fileInput.files[0];
      if (file.type.startsWith('image/')) {
        this.uploadedImage = file;
        this.uploadedVideo = null;
        // Create a URL for the selected image file for preview.
        // Use DomSanitizer to trust the URL
        this.uploadedImageUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file));
        console.log("img",this.uploadedImageUrl)
      }
    }
  }




  openFileInput(fileInput: HTMLInputElement): void {
    fileInput.click();
  }


  sharePub(pub: Pub): void {
    if (pub._id) {
      this.pubService.sharePub(pub._id).subscribe(
        (response: LikeShareResponse) => {
          console.log('Pub shared:', response);
          pub.sharesCount = response.pub.sharesCount;
        },
        (error) => {
          console.error('Failed to share pub:', error);
        }
      );
    } else {
      console.error('Pub _id is undefined');
    }
  }
  publishPub(): void {
    if (this.selectedPub) {
      this.updatePub(this.selectedPub);
    } else {
      if (this.content.trim() !== "" || this.uploadedImage || this.uploadedVideo) {
        const newPub: Pub = {
          user:this.id,
          userLogo: this.userLogo,
          clubName: this.clubName,
          pubTime: this.pubTime,
          imageUrl: this.uploadedImage ? this.uploadedImage.name : null,
          videoUrl: this.uploadedVideo ? this.uploadedVideo.name : null,
          content: this.content,
          sharesCount: 0,
          comments: [],
          likesCount: 0,
          liked: false,
          showOptions: false,
          createdAt: new Date().toISOString(),
        };
  
        const formData: FormData = new FormData();
        formData.append('userId', this.id);
        formData.append('userLogo', this.userLogo);
        formData.append('clubName', this.clubName);
        formData.append('pubTime', this.pubTime);
        formData.append('content', this.content);
        formData.append('sharesCount', '0');
        formData.append('likesCount', '0');
        formData.append('liked', 'false');
        formData.append('showOptions', 'false');
        formData.append('createdAt', new Date().toISOString());
        if (this.uploadedImage) {
          formData.append('image', this.uploadedImage);
        }
        if (this.uploadedVideo) {
          formData.append('video', this.uploadedVideo);
        }
      console.log('Form Data:', formData);
  
      this.pubService.createPub(formData).subscribe(
        (response: CreatePubResponse) => {
          console.log('Pub created:', response);
          this.pubs.unshift(response.pub); // Refresh the list of posts after creating
        },
        (error) => {
          console.error('Failed to create pub:', error);
        }
      );
 
      this.content = '';
      this.uploadedImage = null;
      this.uploadedVideo = null;
      this.closeModel();
    }
  }
}
  
submitComment(pub: Pub): void {
  if (this.userComment.trim() !== "") {
    if (pub._id) {
      const newComment: Comment = {
        text: this.userComment,
        showOptions: false,
        editing: false,
      };
      this.pubService.addComment(pub._id, newComment).subscribe(
        (response) => {
          console.log('Comment added:', response);
          const addedComment: Comment = response.comment;
          pub.comments.push(addedComment); // Add the comment from the response
          this.userComment = '';
        },
        (error) => {
          console.error('Failed to add comment:', error);
        }
      );
    } else {
      console.error('Pub _id is undefined');
    }
  }
}


handleLike(pub: Pub): void {
  if (pub.liked) {
      this.unlikePub(pub);
  } else {
      this.toggleLike(pub);
  }
}

toggleLike(pub: Pub): void {
  if (pub._id) {
    this.pubService.likePub(pub._id).subscribe(
      (response: LikeShareResponse) => {
        console.log('Pub liked:', response);
        pub.likesCount = response.pub.likesCount;
        pub.liked = !pub.liked;
      },
      (error) => {
        console.error('Failed to like pub:', error);
      }
    );
  } else {
    console.error('Pub _id is undefined');
  }
}
unlikePub(pub: Pub): void {
  if (pub._id) {
    this.pubService.unlikePub(pub._id).subscribe(
      (response: LikeShareResponse) => {
        console.log('Pub unliked:', response);
        pub.likesCount = response.pub.likesCount;
        pub.liked = !pub.liked;
      },
      (error) => {
        console.error('Failed to unlike pub:', error);
      }
    );
  } else {
    console.error('Pub _id is undefined');
  }
}

  toggleOptions(comment: Comment): void {
    comment.showOptions = !comment.showOptions;
  }

  editComment(comment: Comment): void {
    comment.showOptions = false;
    comment.editing = true;
  }

  deleteComment(pub: Pub, comment: Comment): void {
    const commentIndex = pub.comments.indexOf(comment);
    if (commentIndex > -1 && pub._id) {
      this.pubService.deleteComment(pub._id, commentIndex).subscribe(
        (response) => {
          console.log('Comment deleted:', response);
          pub.comments = pub.comments.filter((c) => c !== comment); // You might want to get the comments from the response instead
        },
        (error) => {
          console.error('Failed to delete comment:', error);
        }
      );
    } else {
      console.error('Either comment not found or pub _id is undefined');
    }
  }

  showMoreComments(): void {
    this.displayedCommentsCount += 2;
  }

  hideMoreComments(): void {
    this.displayedCommentsCount = 2;
  }

  saveEditedComment(comment: Comment, pub: Pub, index: number, event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      comment.editing = false;
      const newComment = (event.target as HTMLTextAreaElement).value;
      if (newComment.trim() !== '') {
        if (pub._id) {
          console.log(pub._id);
          this.pubService.updateComment(pub._id, index, newComment).subscribe(
            (response) => {
              console.log('Comment updated:', response);
              comment.text = newComment; // You might want to get the comment from the response instead
            },
            (error) => {
              console.error('Failed to update comment:', error);
            }
          );
        } else {
          console.error('Pub _id is undefined');
        }
      }
    }
  }

  togglePubOptions(pub: Pub): void {
    pub.showOptions = !pub.showOptions;
  }
//-----------------------deletePost----------------//
deletePub(pub: Pub): void {
  if (pub._id) {
    this.pubService.deletePub(pub._id).subscribe(
      (response: DeletePubResponse) => {
        console.log('Pub deleted:', response);
        this.pubs = this.pubs.filter((p) => p !== pub);
      },
      (error) => {
        console.error('Failed to delete pub:', error);
      }
    );
  } else {
    console.error('Pub _id is undefined');
  }
}
  
openUpdateModal(pub: Pub): void {
  this.selectedPub= pub;
  this.content = pub.content;
  this.uploadedImageUrl = pub.imageUrl !== null ? pub.imageUrl : null;
this.uploadedVideoUrl = pub.videoUrl !== null ? pub.videoUrl : null;
  const modelDiv = document.getElementById("myModal");
  if (modelDiv != null) {
    modelDiv.style.display = "block";
  }
}
  
updatePub(pub: Pub): void {
  if (this.content.trim() !== "" || this.uploadedImage || this.uploadedVideo) {
    const formData: FormData = new FormData();
    if (pub._id) {
      formData.append('_id', pub._id); // Add the postId to the FormData object
    }
    formData.append('userLogo', this.userLogo);
    formData.append('clubName', this.clubName);
    formData.append('pubTime', this.pubTime);
    formData.append('content', this.content);
    formData.append('sharesCount', '0');
    formData.append('likesCount', '0');
    formData.append('liked', 'false');
    formData.append('showOptions', 'false');
    formData.append('createdAt', new Date().toISOString());
    if (this.uploadedImage) {
      formData.append('image', this.uploadedImage);
    }
    if (this.uploadedVideo) {
      formData.append('video', this.uploadedVideo);
    }

    console.log('Form Data:', formData); // Log the form data to the console

    // Make the HTTP request to update the post
    this.pubService.updatePub(formData).subscribe(
      (response) => {
        console.log('Pub updated:', response);
        this.fetchPubs(); // Refresh the list of posts after updating
      },
      (error) => {
        console.error('Failed to update pub:', error);
      }
    );

    this.content = "";
    this.uploadedImage = null;
    this.uploadedVideo = null;
    this.closeModel();
  }
}

}